import { CmsStartBuildingWidget } from './types';

export default {
  heading: 'Start Building Your First Device!',
  subheading:
    'Quickly take devices to end-users with full control over the device operating system and application deployments via over-the-air updates that make managing devices a breeze.',
  buildSteps: ['Configure OS Features', 'Upload Apps and Assets', 'Deploy Over-The-Air Updates'],
  imageUrl: 'https://mcdn.bymason.com/runway/controller-v2/cms-asset-store/get-started-rocket.png',
  selectWorkflowHeading: 'Do you want to build with your Android app or a Mason Sample app?',
  selectSampleFlowCta: {
    caption: 'Sample app',
    subcaption: `Use one of Mason’s sample apps to see how easy and powerful Mason is`,
  },
  selectCustomFlowCta: {
    caption: 'Using your app',
    subcaption: 'Upload your own application files to get started with Mason',
  },
  startCta: {
    caption: 'Start Building',
    subcaption: 'For Free',
  },
  footerClosingText: 'More of a technical user?',
  footerCtaText: 'Learn about our CLI tool',
} as CmsStartBuildingWidget;
